
import comdetMain from '@/components/detection/comdetMain'
import freeDetect from '@/mixins/freeDetect'

export default {
  components: {
    comdetMain,
  },
  mixins: [freeDetect],
  data() {
    return {
      dialogVisible: false,
      resultShow: false,
      input: this.$route.query.url ? this.$route.query.url : "",
      url: "",
      ischecking: false,
      nc: null,
    };
  },
  created() {
    this.$route.query.url ? this.check() : ''
  },
  methods: {
    check() {
      if (this.input.trim() == "") return this.$message.error("查询不能为空")
      !this.$store.state.isLogin ? this.scrollyz() : this.search()
    },
    search(){
      this.resultShow = false
      this.ischecking = true
      this.url = this.input.trim()
      this.$nextTick(() => this.resultShow = true)
    },
    checkok() {
      this.ischecking = false
    }
  }
}
